<template>
  <v-container>
    <v-form ref="form3" v-on:submit.prevent v-model="isValid" lazy-validation>
      <v-container>
        <v-row>
          <v-col>
            <v-checkbox
              v-model="terms"
              required
              label="J'ai lu et j'accepte les termes et conditions. (obligatoire)"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="8">
            <div
              style="min-height: 160px;overflow-x:auto;max-height: 160px;background-color: white"
            >
              <span>
                <p>
En utilisant R’Cog vous acceptez et vous vous engagez à respecter les droits d'auteur et la propriété intellectuelle. Nous vous demandons de ne pas partager du contenu soumis au copyright sans l'autorisation du titulaire des droits. Nous vous encourageons à créer un contenu unique pour valoriser votre créativité. En cas de violation avérée des droits d'auteur, nous nous réservons le droit de prendre les mesures nécessaires, de supprimer le(s) contenu(s) et de suspendre le compte de l'utilisateur concerné. Nous vous invitons à respecter les droits de propriété intellectuelle des outils que vous souhaitez partager. Votre acceptation à cette clause est essentielle pour garantir une utilisation éthique et légale de notre plateforme. Nous comptons sur votre compréhension et votre respect des droits de propriété intellectuelle pour préserver une communauté éthique.
                </p>
              </span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h3>Sources bibliographiques (normes APA)<sup>*</sup></h3>
          </v-col>
          <v-col cols="4">
            <v-checkbox
              :disabled="sources && !!sources.length"
              v-model="noSources"
              :required="sources && !sources.length"
              label="Absence d'études / Avis d'expert(s)"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="text-center">
              <v-btn
                disabled
                x-small
                color="blue-grey"
                class="ma-2 white--text"
                fab
                elevation="0"
              >
                <v-icon dark>
                  mdi-plus
                </v-icon>
              </v-btn>
              <v-icon>
                mdi-arrow-right
              </v-icon>
              <v-btn
                class="ma-2 white--text"
                color="blue-grey"
                @click="addSource('article')"
              >
                Article
              </v-btn>

              <v-btn
                color="blue-grey"
                class="ma-2 white--text"
                @click="addSource('livre')"
              >
                Livre
              </v-btn>

              <v-btn
                class="ma-2 white--text"
                color="blue-grey"
                @click="addSource('chapitre')"
              >
                Chapitre de livre
              </v-btn>
              <v-btn
                class="ma-2 white--text"
                color="blue-grey"
                @click="addSource('thèse')"
              >
                Thèse de doctorat
              </v-btn>
              <v-btn
                class="ma-2 white--text"
                color="blue-grey"
                @click="addSource('mémoire')"
              >
                Mémoire
              </v-btn>
              <v-btn
                class="ma-2 white--text"
                color="blue-grey"
                @click="addSource('internet')"
              >
                Page internet
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row v-for="(source, index) in sources" :key="index">
          <v-col class="text-center">
            <v-text-field
              :prepend-icon="getIconByType(source.type)"
              label="Sources bibliographiques (normes APA)*"
              v-model="sources[index].source"
              :append-outer-icon="
                displayDesignButton(source.type) ? '' : 'mdi-delete'
              "
              required
              :rules="basicRules"
              @click:append-outer="
                displayDesignButton(source.type) ? '' : deleteSource(index)
              "
            />
          </v-col>
          <v-col cols="4" v-if="displayDesignButton(source.type)">
            <v-autocomplete
              label="Design de l'étude"
              required
              filled
              chips
              color="blue-grey lighten-2"
              v-model="sources[index].design"
              :items="designs"
              :rules="basicRules"
              :append-outer-icon="'mdi-delete'"
              @click:append-outer="deleteSource(index)"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="subtitle-2 font-italic text--secondary">
            *L’ensemble des sources utilisées dans la conception de l’activité
            devrons être citées. Celles-ci devront respecter les normes de
            l’American Psychological Association (APA).
          </v-col>
        </v-row>
        <v-row
          v-if="sources && sources.filter(e => e.type === 'article').length > 0"
        >
          <v-col>
            <v-alert class="apa-norm" border="right" color="blue-grey" dark>
              <div
                class="text-subtitle-1 text--secondary"
                style="color:white !important;"
              >
                Article de revue
              </div>
              <div
                class="text-subtitle-2 font-italic text--secondary"
                style="color:white !important;"
              >
                Nom de l’auteur·e, Initiale. (Date). Titre de l’article. Nom de
                la revue, volume(numéro), plage de pages. DOI ou URL
              </div>
            </v-alert>
          </v-col>
        </v-row>
        <v-row
          v-if="sources && sources.filter(e => e.type === 'livre').length > 0"
        >
          <v-col>
            <v-alert border="right" color="blue-grey" dark class="apa-norm">
              <div
                class="text-subtitle-1 text--secondary"
                style="color:white !important;"
              >
                Livre
              </div>
              <div
                class="text-subtitle-2 font-italic text--secondary"
                style="color:white !important;"
              >
                Nom de l’auteur·e, Initiale. (Date). Titre du livre (édition,
                volume). Nom de la maison d’édition. DOI ou URL
              </div>
            </v-alert>
          </v-col>
        </v-row>
        <v-row
          v-if="
            sources && sources.filter(e => e.type === 'chapitre').length > 0
          "
        >
          <v-col>
            <v-alert border="right" color="blue-grey" dark class="apa-norm">
              <div
                class="text-subtitle-1 text--secondary"
                style="color:white !important;"
              >
                Chapitre
              </div>
              <div
                class="text-subtitle-2 font-italic text--secondary"
                style="color:white !important;"
              >
                Nom de l’auteur·e, Initiale. (Date). Titre du chapitre. Dans
                Initiale. Nom de l’auteur·e & Initiale. Nom de l’auteur·e
                (dirs.), Titre du livre (pp. plage de pages du chapitre). Nom de
                la maison d’édition. DOI ou URL
              </div>
            </v-alert>
          </v-col>
        </v-row>
        <v-row
          v-if="sources && sources.filter(e => e.type === 'thèse').length > 0"
        >
          <v-col>
            <v-alert border="right" color="blue-grey" dark class="apa-norm">
              <div
                class="text-subtitle-1 text--secondary"
                style="color:white !important;"
              >
                Thèse ou doctorat
              </div>
              <div
                class="text-subtitle-2 font-italic text--secondary"
                style="color:white !important;"
              >
                Nom de l’auteur·e, Initiale. (Date). Titre de la thèse [Thèse de
                doctorat, Nom de l’établissement]. Nom de la base de données.
                URL
              </div>
            </v-alert>
          </v-col>
        </v-row>
        <v-row
          v-if="sources && sources.filter(e => e.type === 'mémoire').length > 0"
        >
          <v-col>
            <v-alert border="right" color="blue-grey" dark class="apa-norm">
              <div
                class="text-subtitle-1 text--secondary"
                style="color:white !important;"
              >
                Mémoire
              </div>
              <div
                class="text-subtitle-2 font-italic text--secondary"
                style="color:white !important;"
              >
                Nom de l’auteur·e, Initiale. (Date). Titre du mémoire [Mémoire,
                Nom de l’établissement]. Nom de la base de données. URL
              </div>
            </v-alert>
          </v-col>
        </v-row>
        <v-row
          v-if="
            sources && sources.filter(e => e.type === 'internet').length > 0
          "
        >
          <v-col>
            <v-alert border="right" color="blue-grey" dark class="apa-norm">
              <div
                class="text-subtitle-1 text--secondary"
                style="color:white !important;"
              >
                Page internet
              </div>
              <div
                class="text-subtitle-2 font-italic text--secondary"
                style="color:white !important;"
              >
                Nom de l’auteur·e, Initiale. (année, jour mois). Titre du
                document. Nom du site. Consulté le Date. URL
              </div>
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div style="text-align:right">
              <v-btn class="mr-2" @click="addAndSaveDraft()">{{
                $t("saveDraft")
              }}</v-btn>
              <v-btn @click="previousStep()">Étape précèdente</v-btn>
              <v-btn @click="add()" :disabled="!isFormValid">Publier</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Step3",
  created() {
    if (this.isDraft) {
      this.loadDataDraft();
    }
  },
  computed: {
    ...mapGetters({
      activity: "activities/getActivity"
    }),
    isFormValid() {
      return this.sources
        ? (this.noSources || this.sources.length > 0) &&
            this.terms &&
            this.isValid
        : false;
    }
  },
  props: {
    previousStep: { type: Function },
    publish: { type: Function },
    saveDraft: { type: Function },
    isDraft: { type: Boolean }
  },
  methods: {
    ...mapActions({ validateStep3: "activities/validateStep3" }),
    add() {
      if (this.validate()) {
        this.validateStep3(this.constructActivityStep3());
        this.publish();
      }
    },
    loadDataDraft() {
      this.sources = this.activity.sourcesBibliographique;
    },
    addAndSaveDraft() {
      this.validateStep3(this.constructActivityStep3());
      this.saveDraft();
    },
    constructActivityStep3() {
      return {
        sourcesBibliographique: this.sources,
        terms: this.terms
      };
    },
    deleteSource: function(index) {
      this.sources.splice(index, 1);
    },
    addSource(type) {
      this.noSources = false;
      this.sources.push({ type: type, source: "", design: null });
    },
    getIconByType(type) {
      switch (type) {
        case "article":
          return "mdi-newspaper-variant-outline ";
        case "internet":
          return "mdi-web";
        case "livre":
          return "mdi-book-open-outline ";
        case "chapitre":
          return "mdi-book-outline";
        case "thèse":
          return "mdi-school-outline";
        case "mémoire":
          return "mdi-notebook-outline";
      }
    },
    displayDesignButton(type) {
      return ["article", "thèse", "mémoire"].includes(type);
    },
    validate() {
      return this.$refs.form3.validate() && this.terms;
    }
  },
  data() {
    return {
      isValid: false,
      terms: false,
      sources: [],
      moyensMesure: "",
      precautions: "",
      loader: false,
      gestionCapicitesTransfert: "",
      cadreTheorique: "",
      noSources: false,
      sourcesBibliographique: "",
      basicRules: [v => !!v || "Ce champ est requis"],
      designs: [
        "Etude de cas",
        "Etude de cohorte",
        "Guide de pratique clinique",
        "Synthèse clinique",
        "Revue systématique",
        "Méta-analyse",
        "Essai contrôlé randomisé",
        "Etude comparative randomisée",
        "Etude retrospective",
        "Série de cas"
      ]
    };
  }
};
</script>

<style scoped>
.font-size-stars {
  font-size: 26px;
}

.apa-norm {
  margin-bottom: -11px !important;
  padding: 12px !important;
}
</style>
